let activeAlert = false;

export function alertUser(message?: string) {
  if (!activeAlert) {
    activeAlert = true;
    alert(message || 'An error has occurred, data may not be properly updated');
    setTimeout(() => activeAlert = false, 500);
  }
}
